import type { CollectionFieldPathField } from '#layers/data-model/public';

/**
 * Studio-only fields come from Studio schema overrides and do not exist in the Engine schema, so
 * the Engine rejects any filter that references them. Pass as a field path picker's `includeField`.
 */
export function isEngineFilterableField(_collection: unknown, field: Pick<CollectionFieldPathField, 'isStudioOnly'>): boolean {
	return field.isStudioOnly !== true;
}
